<template>
<div id="contents">
</div><!-- #contents -->
</template>

<script>
export default {
  name: 'recruit_2026_redirect',
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
      window.location.href = '/recruit_2027';
    },ts.$parent.page_load_time)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/recruit_2026_redirect.vue